import { applyMiddleware, createStore } from 'redux';
import { persistReducer, persistStore } from 'redux-persist';
import storage from 'redux-persist/lib/storage/session';
import thunk from 'redux-thunk';
import { sessionMiddleware } from './middleware';
import rootReducer from './rootReducer';

const storageConfig = {
  key: 'root',
  storage: storage,
  blacklist: ['offerDetails', 'availabilityDates', 'sessionManager', 'confirmation'],
};

const persistedReducer = persistReducer(storageConfig, rootReducer);
const store = createStore(persistedReducer, applyMiddleware(sessionMiddleware, thunk));
const persistor = persistStore(store);

const persistConfig = { store, persistor };
export default persistConfig;
